import { render, staticRenderFns } from "./ControlWidgetShape.vue?vue&type=template&id=4cd1bf5b&scoped=true"
import script from "./ControlWidgetShape.vue?vue&type=script&lang=js"
export * from "./ControlWidgetShape.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgetShape.vue?vue&type=style&index=0&id=4cd1bf5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd1bf5b",
  null
  
)

export default component.exports